import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next/';
import _ from 'lodash';

import './LoadBets.scss';
import Icon from 'src/components/Icon/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/configs/store';
import KeyboardEventHandler from 'react-keyboard-event-handler';

function LoadBets() {
  const [betId, setBetId] = useState('');
  const [ticketCode, setTicketCode] = useState('');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { tempBets } = useSelector((state:RootState) => state.betslip);

  const handleBookBet = async (e) => {
    e.preventDefault();
    await dispatch.betslip.bookBet(betId);
  };

  const addBetsToBetslip = async () => {
    await dispatch.peripherals.addBetsToBetslip(ticketCode);
  };

  const reuseSelections = async (e) => {
    e.preventDefault();
    await dispatch.betslip.reuseLastSelections();
  };

  const checkKey = (key, e) => {
    if (key === 'f3'){
      reuseSelections(e);
    }
  };

  return (
    <div className="reuse">
      {
        !_.isEmpty(tempBets) && (
          <KeyboardEventHandler
            handleFocusableElements={ true }
            handleKeys={ ['all'] }
            onKeyEvent={ checkKey }
          />
        )
      }
      <button
        type="button"
        className={
          classNames({
            'reuse__button': true,
            'reuse__button--disabled': _.isEmpty(tempBets)
          })
        }
        onClick={ reuseSelections }
      >{ t('betResult.reuse') }</button>
      <div className="reuse__tickets-container">
        <label className="reuse__label">{ t('betResult.ticketCode') }</label>
        <input className="reuse__input" type="text" onChange={ (e) => setTicketCode(e.target.value) } />
        <button
          className={
            classNames({
              'reuse__submit' : true,
              'reuse__submit--disabled': ticketCode === ''
            })
          }
          disabled = { ticketCode === '' }
          onClick={ addBetsToBetslip }
        >
          <Icon
            icon="return"
            className={
              classNames({
                'fast-mode__check': true,
                'fast-mode__check--disabled': ticketCode === ''
              })
            }
          />
        </button>
      </div>
      <div className="reuse__tickets-container">
        <label className="reuse__label">{ t('betResult.loadBet') }</label>
        <input className="reuse__input" type="text" onChange={ (e) => setBetId(e.target.value) } />
        <button
          className={
            classNames({
              'reuse__submit' : true,
              'reuse__submit--disabled': betId === ''
            })
          }
          onClick={ handleBookBet }
          disabled = { betId === '' }
        >
          <Icon
            icon="return"
            className={
              classNames({
                'fast-mode__check': true,
                'fast-mode__check--disabled': betId === ''
              })
            }
          />
        </button>
      </div>
    </div>
  );
}

export default LoadBets;
